import * as React from "react";
import {IDatePickerProps} from "myshubhlife-component/form/FormInterfaceProps";
import { DatePicker } from "web-com";

const DatePickerField = (props: IDatePickerProps) => {
    const onDateClick = (value) => {
        props.handleFormChange(value, props.index, "value");
        props.handleFormChange("", props.index, "errorMsg");
    };
    return (
    <div className="s-form-group-field">
      <DatePicker
         label={props.field.label}
         preSelectedDate={props.field.value || ""}
         onDateClick={onDateClick}
      />
      {props.field.errorMsg ?
        <div className="error-message flex-center-row">
            {props.field.errorMsg}
        </div> : null}
    </div>
  );
};

export default DatePickerField;
